import React, { useState, useEffect } from "react";
import { Input, Select,Space } from "antd";
import schoolsData from "../data/schools.json";
import FocusOutside from "./FocusOutside";
const { Option } = Select;

const AddressInput = ({ value, personalData, schoolData, visitedPlaces, onChange, onBlur }) => {
  const [address, setAddress] = useState(value || { type: "", name:"", street: "", housenumber:"", postalCode: "", city: "" });

const [isEditing,SetIsEditing]=useState(false);
const [selectingSchool, setSelectingSchool] = useState(false);

  const handleAddressChange = (key, newValue) => {
    const newAddress = { ...address, [key]: newValue };
    setAddress(newAddress);
    onChange(newAddress);   // Daten an Parent-Komponente übergeben
  };

  const onClickedOutside = () => {
   SetIsEditing(false); onBlur?.(address);
  }
 
const isSchoolMode = selectingSchool;
const isVisitedMode = address.type === "besuchter Ort";
  

// Überwachung der PLZ-Änderung und API-Abfrage für PLZ

useEffect(() => {
  const fetchPlaceByPostalCode = async (postalCode) => {
    const url = `https://api.zippopotam.us/DE/${postalCode}`;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Kein Ort für die Postleitzahl ${postalCode} gefunden.`);
      const data = await response.json();

      if (data.places && data.places.length > 0) {
        const updatedAddress = { ...address, city: data.places[0]["place name"] };
        setAddress(updatedAddress);
        onChange(updatedAddress);

      }
    } catch (error) {
      console.error("Fehler bei der API-Abfrage:", error);
      setAddress({ ...address, city: address.city });
      
    }
  };

  if (address.postalCode.length === 5 && address.type !== ("andere Schule" || "Stammschule")) {
    fetchPlaceByPostalCode(address.postalCode);
  } else {
    setAddress({ ...address, city: address.city });
  }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [address.postalCode]);
  




 
  

  const handleTypeChange = (value) => {
    let newAddress = { type: value, name:"", street: "", postalCode: "", city: "" };
if (value === "andere Schule") {
    setSelectingSchool(true);   // 👈 nur JETZT Schulmodus
    SetIsEditing(true);
  } else {
    setSelectingSchool(false);
  }

    // Automatische Adresse für "Seminar Esslingen"
    if (value === "Seminar Esslingen") {
      newAddress = {
        type: value,
        name: value,
        street: "Flandernstraße",
        housenumber: "103",
        postalCode: "73732",
        city: "Esslingen"
      };
      
      
    }
    if (value === "Wohnort") {
      newAddress = {
        type: value,
        name: value,
        street: personalData.street,
        housenumber: personalData.housenumber,
        postalCode: personalData.postalCode,
        city: personalData.city
      };
    }
    if (value === "Stammschule") {
      newAddress = {
        type: value,
        name: schoolData.name,
        street: schoolData.street,
        housenumber: schoolData.housenumber,
        postalCode: schoolData.postalCode,
        city: schoolData.city
      };
    }

    setAddress(newAddress);
    onChange(newAddress);
   
    
  };

  return (
    <div>
     <FocusOutside clickedOutside={onClickedOutside}>
  {(
    <Select
      placeholder="Ort"
      value={address.type || undefined}
      onChange={handleTypeChange}
      onClick={() => SetIsEditing(true)}
      style={{ width: "100%", maxWidth: "300px", marginBottom: 5 }}
    >
      <Option value="Wohnort">Wohnort</Option>
      <Option value="Stammschule">Stammschule</Option>
      <Option value="Seminar Esslingen">Seminar Esslingen</Option>
      <Option value="andere Schule">Andere Schule</Option>
      <Option value="anderer Ort">Anderer Ort</Option>
      <Option value="besuchter Ort">Besuchter Ort</Option>
    </Select>
    
  )}

  

  {isVisitedMode && (
    <>
    <Select
      showSearch
      autoFocus
      placeholder="Besuchten Ort auswählen"
      style={{ width: "100%", maxWidth: "300px", marginBottom: 5 }}
      optionFilterProp="label"
      onChange={(value) => {
        const selected = visitedPlaces.find(
          p => `${p.postalCode}-${p.city}-${p.street}-${p.housenumber}` === value
        );
        if (selected) {
          setAddress(selected);
          onChange(selected);
          SetIsEditing(false);
        }
      }}
      onBlur={() => { SetIsEditing(false); onBlur?.(address); }}
    >
      {visitedPlaces.map((place, index) => (
        <Option
          key={index}
          value={`${place.postalCode}-${place.city}-${place.street}-${place.housenumber}`}
          label={`${place.city}, ${place.street} ${place.housenumber}`}
        >
          <div>
            <div>{place.city} ({place.postalCode})</div>
            <div style={{ fontSize: "0.8em", color: "#666" }}>
              {place.street} {place.housenumber}
            </div>
          </div>
        </Option>
      ))}
    </Select>
    </>
  )}


{["Wohnort", "Seminar Esslingen", "anderer Ort"].includes(address.type) && (
  <>
    <Space.Compact style={{ width: "100%" }}>
      <Input
        placeholder="PLZ"
        value={address.postalCode}
        onChange={(e) => handleAddressChange("postalCode", e.target.value)}
        style={{ marginBottom: 5, width: "20%", maxWidth: "70px" }}
      />
      <Input
        placeholder="Ort"
        value={address.city}
        onChange={(e) => handleAddressChange("city", e.target.value)}
        style={{ marginBottom: 5, width: "80%", maxWidth: "230px" }}
      />
    </Space.Compact>

    <Space.Compact style={{ width: "100%" }}>
      <Input
        placeholder="Straße"
        value={address.street || ""}
        onChange={(e) => handleAddressChange("street", e.target.value)}
        style={{ marginBottom: 5, width: "80%", maxWidth: "240px" }}
      />
      <Input
        placeholder="Hausnr."
        value={address.housenumber}
        onChange={(e) => handleAddressChange("housenumber", e.target.value)}
        style={{ marginBottom: 5, width: "20%", maxWidth: "60px" }}
      />
    </Space.Compact>
  </>
)}
{["Stammschule", "andere Schule"].includes(address.type) && (
  <>
  <Select
      showSearch
      autoFocus
      placeholder="Schule auswählen"
      value={address.name || undefined}
      optionLabelProp="label"
      style={{ width: "100%", maxWidth: "300px", marginBottom: 5 }}
      onChange={(value) => {
        const [name, city] = value.split(".");
        const selected = schoolsData.find(
          s => s.name === name && s.city === city
        );

        if (selected) {
          const newAddress = {
            type: "andere Schule",
            name: selected.name,
            city: selected.city,
            street: selected.street,
            housenumber: selected.housenumber,
            postalCode: selected.postalCode
          };
          setAddress(newAddress);
          onChange(newAddress);
          setSelectingSchool(false);
          SetIsEditing(false);
        }
      }}
      onBlur={() => { SetIsEditing(false); onBlur?.(address); }}
    >
  {schoolsData
  .slice() // Kopie des Arrays wird erstellt um nicht das ursprüngliche Array nicht zu verändern.
  .sort((a, b) => {
    const nameCompare = a.name.localeCompare(b.name);
    if (nameCompare !== 0) return nameCompare;
    return a.city.localeCompare(b.city);
  })
  .map((item, index) => (
        <Option
          key={index}
          value={`${item.name}.${item.city}`}
          label={item.name}
        >
          <div>
            <div>{item.name}</div>
            <div style={{ fontSize: "0.8em", color: "#666" }}>
              {item.city}
            </div>
          </div>
        </Option>
      ))}
    </Select>
    <Space.Compact style={{ width: "100%" }}>
      <Input
        placeholder="PLZ"
        value={address.postalCode}
        onChange={(e) => handleAddressChange("postalCode", e.target.value)}
        style={{ marginBottom: 5, width: "20%", maxWidth: "70px" }}
      />
      <Input
        placeholder="Ort"
        value={address.city}
        onChange={(e) => handleAddressChange("city", e.target.value)}
        style={{ marginBottom: 5, width: "80%", maxWidth: "230px" }}
      />
    </Space.Compact>

    <Space.Compact style={{ width: "100%" }}>
      <Input
        placeholder="Straße"
        value={address.street || ""}
        onChange={(e) => handleAddressChange("street", e.target.value)}
        style={{ marginBottom: 5, width: "80%", maxWidth: "240px" }}
      />
      <Input
        placeholder="Hausnr."
        value={address.housenumber}
        onChange={(e) => handleAddressChange("housenumber", e.target.value)}
        style={{ marginBottom: 5, width: "20%", maxWidth: "60px" }}
      />
    </Space.Compact>
  </>
)}

</FocusOutside>
    
    </div>
  );
};

export default AddressInput;